/**
 * Case-insensitive bidirectional substring match, e.g. `'Classic Oak (Beige Felt)'` matches `'Classic Oak'`.
 */
export const looseMatch = (a: string, b: string): boolean => {
  const aL = a.toLowerCase();
  const bL = b.toLowerCase();
  return aL.includes(bL) || bL.includes(aL);
};
